import { createContext } from 'react';
import { UseUserContextResponse } from '~/hooks';

export const UserContext = createContext<UseUserContextResponse | undefined>(undefined);
